
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13063',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13063",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9882",
  "foundations-components": "static-1.8351",
  "foundations-components-legacy": "static-1.1376",
  "foundations-theming": "static-1.4676",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.85",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8249",
  "hub-http-shared-msw-handlers": "static-1.10488",
  "hubspot-dlb": "static-2.1877",
  "hubspot-url-utils": "static-1.4282",
  "HubStyleTokens": "static-2.11705",
  "I18n": "static-7.1653",
  "jasmine-runner": "static-1.6673",
  "marketplace-discovery-studio-lib": "static-1.511",
  "marketplace-storefront-base": "static-1.13126",
  "quartz": "static-1.7334",
  "react-dlb": "static-1.84",
  "react-rhumb": "static-1.16931",
  "reactive-variable-buffer-atom": "static-1.3079",
  "reporting-testing-lib": "static-1.10425",
  "reselect": "static-3.8",
  "settings-ui-lib": "static-1.12744",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7525",
  "ui-addon-i18n": "static-1.11370",
  "ui-addon-react-router-dom": "static-1.9757",
  "unified-auth": "static-1.762",
  "unified-auth-core-lib": "static-1.1044",
  "usage-tracker": "static-1.7581",
  "usage-tracker-core": "static-1.7431",
  "customer-data-property-utils": "static-1.8321",
  "hub-http": "static-1.6438",
  "integrations-lib": "static-1.16873",
  "marketplace-ui-common": "static-1.20512",
  "marketplace-ui-install": "static-1.498",
  "property-management-iframe": "static-1.13913",
  "quartz-config": "static-1.1112",
  "quartz-core": "static-1.6553",
  "quartz-routing": "static-1.764",
  "quick-fetch": "static-1.4074",
  "react": "static-7.190",
  "rpc-client-utils": "static-1.4886",
  "ts-schema": "static-1.4235",
  "ui-universal-auth": "static-1.9248",
  "UIComponents": "static-3.8651",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9849",
  "react-redux": "static-7.75",
  "redux": "static-4.16",
  "styled-components": "static-2.94",
  "bend-plugin-trellis-migration": "static-1.3557",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3611",
  "quartz-webpack": "static-1.3558",
  "bend-plugin-quartz-routing": "static-1.412",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4620",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5099",
  "foundations-theming-specialty": "static-1.2392",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9650",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.53",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5498",
  "react-virtualized": "static-2.103",
  "StyleGuideUI": "static-3.492",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2406",
  "ui-fonts": "static-1.967",
  "ui-images": "static-2.1220",
  "bend-plugin-foundations-theming": "static-1.3159",
  "foundations-theming-base": "static-1.3661",
  "stylex": "static-1.37",
  "HeadJS": "static-2.783",
  "hs-test-utils-bend-plugin": "static-1.3360",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4543",
  "ui-addon-video-player": "static-1.8930",
  "ai-components-ui-library": "static-1.9534",
  "ai-rendering-library": "static-1.10952",
  "chirp-fetch": "static-1.2112",
  "connections-embed-lib": "static-1.1398",
  "copilot-toolkit": "static-1.11700",
  "feedback-loader": "static-1.29700",
  "laboratory-lib": "static-3.7376",
  "marketplace-embed": "static-1.22767",
  "marketplace-ui-details": "static-1.10407",
  "marketplace-ui-reviews": "static-1.20467",
  "marketplace-ui-tracking": "static-1.14682",
  "sanitize-text": "static-1.8373",
  "usage-tracker-multi": "static-1.5995",
  "usage-tracker-session-replay": "static-1.5267",
  "wootric-nps": "static-1.7143",
  "quartz-head": "static-1.999",
  "web-vitals": "static-1.9",
  "apollo-link-hub-http": "static-2.4881",
  "immer": "static-1.94",
  "immerable": "static-1.4375",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2635",
  "reporting-data": "static-1.68492",
  "cssUtils": "static-1.859",
  "flux-actions": "static-1.357",
  "HubStyle": "static-2.12012",
  "PatternValidationJS": "static-1.3121",
  "react-colorpicker": "static-2.10431",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10589",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7571",
  "icons": "static-2.672",
  "marketplace-ui-apps-core": "static-1.19044",
  "storybook-react": "static-1.36",
  "trellis-story-utils": "static-1.4734",
  "foundations-components-test-utils": "static-1.5834",
  "quartz-i18n": "static-1.1009",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.308",
  "ads-unified-auth-lib": "static-1.883",
  "google-sheets-integration-lib": "static-1.886",
  "microsoft-drive-integration-lib": "static-1.1019",
  "surveymonkey-integration-lib": "static-1.330",
  "slack-ui-library": "static-1.10620",
  "fsm": "static-1.3961",
  "customer-data-objects": "static-1.7908",
  "property-translator": "static-1.5619",
  "hs-locale-management": "static-1.237",
  "frontend-preferences-client": "static-1.8152",
  "hs-promise-utils": "static-1.5819",
  "hubspot-apollo-client": "static-1.5101",
  "integrations-error-boundary-lib": "static-1.14288",
  "integrations-tracking-lib": "static-1.5832",
  "native-integrations-shared-strings": "static-1.8001",
  "sanitize": "static-1.4700",
  "superstore": "static-1.4981",
  "ui-shepherd-react": "static-3.10486",
  "ai-settings-ui-library": "static-1.8224",
  "hub-http-janus": "static-1.861",
  "hubspotter-http": "static-1.4806",
  "immutable-less": "static-1.4875",
  "marketplace-ui-client-types": "static-1.17919",
  "nav-meta": "static-1.30318",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18295",
  "ui-product-approvals-common": "static-1.843",
  "ai-studio-lib": "static-1.12294",
  "hubspot-prosemirror": "static-1.18852",
  "integrations-reconnect-lib": "static-1.371",
  "ui-addon-iframeable": "static-1.9300",
  "ui-addon-integrations-directory-panel": "static-2.8249",
  "ui-product-approvals": "static-1.28948",
  "ui-tool-access": "static-1.10377",
  "inbound-db-properties-service-client": "static-1.4002",
  "property-management-common": "static-1.6201",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.558",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1009",
  "quartz-test": "static-1.1009",
  "quartz-tracking": "static-1.713",
  "trellis-components": "static-1.2425",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.296",
  "bender-build-tools": "static-1.3347",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22508",
  "ContentUtils": "static-1.69006",
  "customer-data-objects-ui-components": "static-1.13255",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2722",
  "breeze-engine-core": "static-1.795",
  "breeze-onboarding-components": "static-1.572",
  "customer-data-filters-ui": "static-1.40680",
  "customer-data-reference-ui-components": "static-1.13402",
  "embedded-academy-lib": "static-1.15278",
  "ExportDialog": "static-6.10604",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41866",
  "reporting-snowflake": "static-1.57110",
  "reporting-ui-components": "static-2.65763",
  "reporting-visualizations": "static-1.60568",
  "trellis-theming": "static-1.1180",
  "ui-addon-teams": "static-1.21830",
  "upgrade-components-lib": "static-1.429",
  "magpie-lib": "static-1.5706",
  "navigation-components": "static-1.18681",
  "breeze-engine-lib": "static-1.1517",
  "magpie-types": "static-1.5166",
  "simple-logging-lib": "static-1.3273",
  "fail-safe": "static-1.175",
  "app-governance-lib": "static-1.2246",
  "developer-experience-shared-components": "static-1.10722",
  "purchase-motions-components": "static-1.6256",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.9929",
  "usage-tracker-anonymous": "static-1.5998",
  "usage-tracker-public": "static-1.7392",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3926",
  "reference-resolvers": "static-1.8406",
  "ui-extensibility-client-types": "static-1.4144",
  "hubspot-apollo-cache": "static-1.560",
  "universal-page-editor-lib": "static-1.3235",
  "final-form": "static-1.73",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3399",
  "atom": "static-1.5300",
  "merchandise-lib": "static-1.273",
  "salesImages": "static-1.530",
  "codemirror": "static-5.98",
  "react-codemirror": "static-1.10864",
  "ui-addon-draggable": "static-3.4980",
  "content-assistance-lib": "static-1.8102",
  "content-media-capture": "static-1.5235",
  "customer-data-ui-utilities": "static-1.10050",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24303",
  "growth-payments-core": "static-1.26026",
  "knowledge-content-types": "static-1.8614",
  "payment-link-components": "static-1.24036",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20203",
  "ui-addon-emoji-picker": "static-1.10110",
  "ui-business-units-lib": "static-1.9305",
  "video-components-external": "static-1.11999",
  "video-data-lib": "static-1.35657",
  "navigation-messaging": "static-1.8008",
  "collaboration-sidebar": "static-1.58559",
  "react-dnd-compat": "static-1.4840",
  "batch-promise": "static-1.1769",
  "crm-component-utils": "static-1.39690",
  "crm-properties-common-lib": "static-1.6113",
  "customer-data-properties": "static-1.52364",
  "external-options-client-types": "static-1.4283",
  "framework-data-schema-resolvers": "static-1.7117",
  "property-value-citations": "static-1.2978",
  "reference-resolvers-lite": "static-1.8323",
  "hubspotter-http-shared-msw-handlers": "static-1.10486",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.35",
  "cms-field-types": "static-1.5039",
  "content-icons-ui": "static-1.2294",
  "breeze-artifacts-sdk": "static-1.110",
  "onboarding-journeys-lib": "static-1.740",
  "pulse": "static-1.847",
  "conversations-skeleton-state": "static-1.7473",
  "crm-message-bus": "static-1.43587",
  "customer-data-filters-ui-msw-helpers": "static-1.23115",
  "events-data-lib": "static-1.465",
  "FormUrlGenerator": "static-2.4949",
  "framework-builder-read-service-client": "static-1.4164",
  "framework-data-schema-quick-fetch": "static-1.7022",
  "multi-account-reference-resolvers": "static-1.1220",
  "onboarding-tours": "static-1.17007",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14325",
  "academy-common-lib": "static-1.14738",
  "dashboard-lib": "static-1.82489",
  "getting-started-shared-tasks": "static-1.19066",
  "hubspot-prosemirror-plugins": "static-1.18844",
  "share-with-third-party-component-lib": "static-1.8928",
  "ui-asset-management-lib": "static-1.11314",
  "user-context": "static-1.5337",
  "reporting-plugins": "static-1.10671",
  "reporting-reports": "static-1.68170",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.944",
  "nest": "static-1.462",
  "breeze-engine-chat-components": "static-1.495",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.126",
  "framework-listing-lib": "static-2.29327",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31263",
  "apps-service-types": "static-1.3990",
  "oauth-service-types": "static-1.4478",
  "onboarding-scopes": "static-1.6683",
  "purchase-motions-api": "static-1.6259",
  "signup-constants": "static-1.19451",
  "signup-ui-url-generator": "static-2.8282",
  "onboarding-tours-client": "static-1.5221",
  "one-click-checkout": "static-1.305",
  "platform-infra-nav-components": "static-1.7827",
  "subscription-experience-data-types": "static-1.15169",
  "crm-record-cards-service-types": "static-1.3736",
  "location-customization-utils-lib": "static-1.9946",
  "redux-thunk": "static-2.43",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.74",
  "ui-coaching-tips": "static-1.29171",
  "content-media-composition-data-lib": "static-1.13039",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4649",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.557",
  "ui-addon-opt": "static-4.8586",
  "commerce-tours-lib": "static-1.6502",
  "growth-onboarding-reliability": "static-1.5304",
  "sales-checkout-service-client": "static-1.3760",
  "data-token-picker": "static-1.16785",
  "FileManagerLib": "static-1.39943",
  "content-media-compositions": "static-2.17046",
  "media-bridge-lib": "static-1.19305",
  "chatspot-widget-iframe": "static-1.22499",
  "collaboration-sidebar-common": "static-1.3356",
  "marketing-platform-lib": "static-1.7093",
  "card-properties-lib": "static-1.44858",
  "commerce-subscription-lib": "static-1.37633",
  "crm-actions": "static-1.6574",
  "crm-cards-sdk": "static-1.44321",
  "customer-data-properties-shared-msw-handlers": "static-1.9815",
  "customer-data-tracking": "static-1.7107",
  "hs-resources": "static-1.411",
  "calling-global-api": "static-1.65291",
  "calling-internal-common": "static-1.31540",
  "calling-lifecycle-internal": "static-1.66673",
  "calling-lifecycle-messages": "static-1.58967",
  "commerce-products-lib": "static-1.10356",
  "conditional-properties-service-client": "static-1.3954",
  "crm-links": "static-1.6543",
  "crm-index-visualization-core": "static-1.4442",
  "crm-pipelines-api-client-types": "static-1.4292",
  "formula-editor": "static-1.14643",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4368",
  "meetings-icalendar-utils-lib": "static-1.859",
  "multi-currency-client-types": "static-1.3848",
  "object-builder-ui-client": "static-1.49468",
  "pipeline-validation-client-types": "static-1.4124",
  "smart-property-lib": "static-1.8132",
  "tiered-pricing": "static-1.1823",
  "topics-actions-lib": "static-1.382",
  "ui-addon-form-validation": "static-1.11210",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.236",
  "bend-plugin-pulse": "static-1.350",
  "event-emitter": "static-1.1176",
  "fast-json-patch": "static-1.66",
  "restore-request-side-panel-lib": "static-1.1484",
  "growth-data-modal": "static-1.5786",
  "growth-onboarding-confetti": "static-1.3285",
  "growth-onboarding-next-action-utils": "static-1.2550",
  "onboarding-tours-utils": "static-1.1073",
  "ui-shepherd-tracker": "static-1.7867",
  "academy-service-client": "static-1.3914",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39802",
  "SafeStorage": "static-1.4627",
  "video-embed": "static-1.36491",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24876",
  "viral-links-lib": "static-1.7297",
  "nested-table": "static-1.459",
  "timezone-utils": "static-2.5471",
  "getting-started-shared-tasks-store": "static-1.18184",
  "campaign-roi-lib": "static-1.9940",
  "ui-addon-calendars": "static-2.5550",
  "customer-data-views-management": "static-1.25899",
  "framework-data-table": "static-2.12406",
  "nudge-client-utils": "static-1.3034",
  "nudge-custom-ui-functions": "static-1.1388",
  "switchboard-lib": "static-1.444",
  "access-check-ui-lib": "static-1.1437",
  "app-users-service-client": "static-1.5842",
  "app-users-service-types": "static-1.5250",
  "mini-checkout-client": "static-1.27400",
  "onboarding-utils": "static-1.5587",
  "permissions-shared-i18n-strings-fe": "static-1.2105",
  "ui-coaching-tips-shared-config": "static-1.29156",
  "checkout-sdk": "static-3.24243",
  "payment-method-components": "static-1.7072",
  "touchless-buying-components": "static-1.6111",
  "upgrade-catalog-service-types": "static-1.3709",
  "edison-service-client-types": "static-1.613",
  "growth-onboarding-feedback-components": "static-1.6806",
  "audio-components": "static-1.6243",
  "FileManagerImages": "static-1.37454",
  "video-components": "static-1.14001",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92693",
  "customer-data-sidebar": "static-2.46603",
  "enrichment-properties-lib": "static-1.17694",
  "ui-addon-draggable-compat": "static-2.4485",
  "universal-record-utils-lib": "static-1.1657",
  "commerce-billing-lib": "static-1.19887",
  "commerce-shared-components-lib": "static-1.19090",
  "commerce-tools-ui-lib": "static-1.10920",
  "crm-fe-perf": "static-1.23123",
  "calling-error-reporting": "static-1.31547",
  "shared-worker-versioning": "static-1.11263",
  "calling-usage-tracker": "static-1.6763",
  "voice-sms-access-library": "static-1.1809",
  "commerce-permissions": "static-1.1001",
  "products-iframe-lib": "static-1.8456",
  "products-ui-components-shared-msw-handlers": "static-1.10870",
  "crm-index-associations-lib": "static-1.6665",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10571",
  "sales-views-client-types": "static-1.4481",
  "bark-lib": "static-1.16729",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.540",
  "policy-lib": "static-1.7017",
  "react-tinymce": "static-1.55831",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10634",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54957",
  "tinymce-plugins": "static-1.58071",
  "tinymce-themes": "static-1.56927",
  "onboarding-data-sync-lib": "static-1.2356",
  "growth-onboarding-next-action-components": "static-1.2578",
  "user-context-client": "static-1.4754",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4757",
  "outpost": "static-1.4387",
  "draft-convert": "static-2.76",
  "draft-extend": "static-3.79",
  "draft-js": "static-5.81",
  "draft-plugins": "static-2.22052",
  "sales-email-signature-service-client": "static-1.4069",
  "ts-utils-lib": "static-1.399",
  "crm-export-dialog": "static-1.6509",
  "crm-view-components": "static-1.945",
  "react-beautiful-dnd": "static-1.66",
  "customer-data-associations": "static-1.7556",
  "nudge-custom-function-registry": "static-1.2791",
  "nudge-renderer-utils": "static-1.3110",
  "whisper-core-api": "static-1.7180",
  "InboxConnectUtils": "static-4.15413",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46703",
  "hub-http-rxjs": "static-1.826",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4215",
  "company-details-components": "static-1.6426",
  "react-performance-metrics-lib": "static-1.778",
  "pricing-pages-ui-components": "static-1.15355",
  "quote-checkout-service-types": "static-1.3679",
  "social-insights-client-types": "static-1.22664",
  "crm_universal": "static-1.22391",
  "customer-data-email": "static-1.18420",
  "card-payment-highlight-lib": "static-1.37827",
  "card-subscription-highlight-lib": "static-1.40056",
  "commerce-contract-lib": "static-1.13097",
  "invoices-highlight-card-lib": "static-1.55460",
  "orders-highlight-card-lib": "static-1.22047",
  "products-highlight-card-lib": "static-1.18639",
  "quotes-highlight-card-lib": "static-1.72695",
  "crm-source-interpretation-lib": "static-1.5558",
  "crm-object-search-query-utilities": "static-1.10073",
  "utility-belt": "static-1.2756",
  "payments-enrollment-embed-lib": "static-1.23666",
  "stripe-embedded-components": "static-1.7891",
  "customer-data-rte": "static-1.33523",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6160",
  "payments-post-enroll-local-storage-lib": "static-1.5331",
  "qrcode-generator": "static-1.72",
  "quotes-client-types": "static-1.38785",
  "calling-orchestration-schema": "static-1.36586",
  "react-reducer-toolkit": "static-1.16224",
  "hub-http-contrib": "static-1.3263",
  "interframe": "static-3.4979",
  "tinymce-data": "static-1.41042",
  "ui-addon-sales-email": "static-1.5437",
  "layout-dnd-components": "static-1.12858",
  "layout-dnd-utils": "static-1.11833",
  "ui-brand-identity-lib": "static-1.16139",
  "NamespacedHubStyle": "static-2.9206",
  "meetings-connect-utils-lib": "static-1.7831",
  "access-control-lib": "static-1.10662",
  "EmailComponents": "static-1.55408",
  "EmailData": "static-1.54086",
  "redux-less": "static-2.9704",
  "company-details-service-types": "static-1.4163",
  "segments-query-core": "static-1.1647",
  "pricing-pages-api": "static-1.15220",
  "sequences-lib": "static-1.8417",
  "ui-gdpr-components": "static-1.10578",
  "products-ui-components": "static-1.40874",
  "accounting-integrations-ui-components": "static-1.7433",
  "invoices-ui-lib": "static-1.55476",
  "commerce-products-api": "static-1.2613",
  "invoices-iframe-lib": "static-1.57534",
  "quotes-modal-lib": "static-1.103373",
  "quotes-ui-lib": "static-1.81416",
  "stripe-connect-js": "static-1.74",
  "draft-content-plugins": "static-1.28787",
  "ContentData": "static-1.69081",
  "layout-data-lib": "static-1.10158",
  "ContentComponents": "static-2.71962",
  "marketing-contacts-lib": "static-1.10816",
  "marketing-email-service-types": "static-1.2060",
  "messaging-editing-lib": "static-1.46984",
  "messaging-usage-based-billing-components-lib": "static-1.1846",
  "automation-ui-source-apps": "static-1.19520",
  "automation-ui-types": "static-1.20438",
  "messaging-types-lib": "static-1.46721",
  "onboarding-settings-client": "static-1.4733",
  "sequences-client-types-lib": "static-1.8274",
  "commerce-tax-lib": "static-1.765",
  "price-books-api": "static-1.1575",
  "price-books-components": "static-1.1633",
  "property-description-translator": "static-1.4063",
  "ramp-editor": "static-1.757",
  "commerce-analytics-service-client": "static-1.3748",
  "totals-ui-components": "static-1.24166",
  "SalesContentIndexUI": "static-3.9541",
  "advanced-menus-core": "static-1.15484",
  "advanced-menus-lib": "static-1.12369",
  "ui-memberships-settings-lib": "static-1.34666",
  "automation-ui-ubb": "static-1.6354",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7558",
  "data-token-views": "static-1.16766",
  "forms-utils-lib": "static-1.12986",
  "payments-embed-points-lib": "static-1.13475",
  "simple-menus-core": "static-1.15483",
  "simple-menus-lib": "static-1.17000",
  "videoconference-integration-components": "static-1.7146",
  "marketing-contacts-client": "static-1.7731",
  "mc-hard-limits-client-types": "static-1.125",
  "automation-applications-service-types": "static-1.3637",
  "automation-platform-service-types": "static-1.2648",
  "ContentEditorUI": "static-2.77747",
  "short-messages-app-service-client": "static-1.4145",
  "web-interactives-components": "static-1.14142",
  "web-interactives-data": "static-1.14143",
  "messaging-shared-utils-lib": "static-1.1295",
  "messaging-user-info-utils-lib": "static-1.1465",
  "email-portal-health-service-types": "static-1.1202",
  "line-items-api": "static-1.1010",
  "commerce-totals-service-types": "static-1.3973",
  "FireAlarmUi": "static-1.4665",
  "sales-templates-service-types-lib": "static-1.4325",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22374",
  "automation-ui-usage-tracking": "static-1.21837",
  "data-studio-ubb": "static-1.3369",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27531",
  "content-management-data-lib": "static-1.5836",
  "copilot-plugins": "static-1.11672",
  "cta-picker": "static-1.36954",
  "customer-agent-discovery-components-lib": "static-1.3735",
  "editor-components": "static-1.13547",
  "editor-iframe-lib": "static-1.8705",
  "error-messaging-js": "static-1.5419",
  "FormsCommonComponents": "static-1.86441",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.68",
  "redux-request-state": "static-1.10873",
  "SharedLegalStrings": "static-1.1970",
  "smart-content-core": "static-1.43036",
  "smart-content-lib": "static-1.43689",
  "social-composer-lib": "static-1.60004",
  "structured-content-lib": "static-1.25781",
  "theme-previewer-lib": "static-1.53807",
  "tinymce-copilot": "static-1.17025",
  "xray-recommendation-lib": "static-1.8182",
  "automation-ui-routing": "static-1.21795",
  "sql-reporting-client-types": "static-1.5829",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42666",
  "campaigns-utils-lib": "static-1.3422",
  "reporting-enablement": "static-1.23665",
  "forms-ai-lib": "static-1.4658",
  "codemirror-dlb": "static-1.59306",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6663",
  "report-customization-components": "static-1.13755",
  "data-quality-ui-library": "static-1.13627",
  "reporting-filters": "static-1.871",
  "reporting-insights-lib": "static-1.2412"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13063",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9882",
  "foundations-components": "/foundations-components/static-1.8351",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1376",
  "foundations-theming": "/foundations-theming/static-1.4676",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.85",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8249",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10488",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "HubStyleTokens": "/HubStyleTokens/static-2.11705",
  "I18n": "/I18n/static-7.1653",
  "jasmine-runner": "/jasmine-runner/static-1.6673",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.511",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13126",
  "quartz": "/quartz/static-1.7334",
  "react-dlb": "/react-dlb/static-1.84",
  "react-rhumb": "/react-rhumb/static-1.16931",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3079",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10425",
  "reselect": "/reselect/static-3.8",
  "settings-ui-lib": "/settings-ui-lib/static-1.12744",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7525",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11370",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9757",
  "unified-auth": "/unified-auth/static-1.762",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1044",
  "usage-tracker": "/usage-tracker/static-1.7581",
  "usage-tracker-core": "/usage-tracker-core/static-1.7431",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8321",
  "hub-http": "/hub-http/static-1.6438",
  "integrations-lib": "/integrations-lib/static-1.16873",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20512",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.498",
  "property-management-iframe": "/property-management-iframe/static-1.13913",
  "quartz-config": "/quartz-config/static-1.1112",
  "quartz-core": "/quartz-core/static-1.6553",
  "quartz-routing": "/quartz-routing/static-1.764",
  "quick-fetch": "/quick-fetch/static-1.4074",
  "react": "/react/static-7.190",
  "rpc-client-utils": "/rpc-client-utils/static-1.4886",
  "ts-schema": "/ts-schema/static-1.4235",
  "ui-universal-auth": "/ui-universal-auth/static-1.9248",
  "UIComponents": "/UIComponents/static-3.8651",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9849",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.94",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3557",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3611",
  "quartz-webpack": "/quartz-webpack/static-1.3558",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.412",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4620",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5099",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2392",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9650",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.53",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5498",
  "react-virtualized": "/react-virtualized/static-2.103",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2406",
  "ui-fonts": "/ui-fonts/static-1.967",
  "ui-images": "/ui-images/static-2.1220",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3159",
  "foundations-theming-base": "/foundations-theming-base/static-1.3661",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.783",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3360",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4543",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8930",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9534",
  "ai-rendering-library": "/ai-rendering-library/static-1.10952",
  "chirp-fetch": "/chirp-fetch/static-1.2112",
  "connections-embed-lib": "/connections-embed-lib/static-1.1398",
  "copilot-toolkit": "/copilot-toolkit/static-1.11700",
  "feedback-loader": "/feedback-loader/static-1.29700",
  "laboratory-lib": "/laboratory-lib/static-3.7376",
  "marketplace-embed": "/marketplace-embed/static-1.22767",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10407",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20467",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14682",
  "sanitize-text": "/sanitize-text/static-1.8373",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5995",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5267",
  "wootric-nps": "/wootric-nps/static-1.7143",
  "quartz-head": "/quartz-head/static-1.999",
  "web-vitals": "/web-vitals/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4881",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4375",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2635",
  "reporting-data": "/reporting-data/static-1.68492",
  "cssUtils": "/cssUtils/static-1.859",
  "flux-actions": "/flux-actions/static-1.357",
  "HubStyle": "/HubStyle/static-2.12012",
  "PatternValidationJS": "/PatternValidationJS/static-1.3121",
  "react-colorpicker": "/react-colorpicker/static-2.10431",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10589",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7571",
  "icons": "/icons/static-2.672",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19044",
  "storybook-react": "/storybook-react/static-1.36",
  "trellis-story-utils": "/trellis-story-utils/static-1.4734",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5834",
  "quartz-i18n": "/quartz-i18n/static-1.1009",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.308",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.883",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.886",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1019",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.330",
  "slack-ui-library": "/slack-ui-library/static-1.10620",
  "fsm": "/fsm/static-1.3961",
  "customer-data-objects": "/customer-data-objects/static-1.7908",
  "property-translator": "/property-translator/static-1.5619",
  "hs-locale-management": "/hs-locale-management/static-1.237",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8152",
  "hs-promise-utils": "/hs-promise-utils/static-1.5819",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5101",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14288",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5832",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8001",
  "sanitize": "/sanitize/static-1.4700",
  "superstore": "/superstore/static-1.4981",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10486",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8224",
  "hub-http-janus": "/hub-http-janus/static-1.861",
  "hubspotter-http": "/hubspotter-http/static-1.4806",
  "immutable-less": "/immutable-less/static-1.4875",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17919",
  "nav-meta": "/nav-meta/static-1.30318",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18295",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.843",
  "ai-studio-lib": "/ai-studio-lib/static-1.12294",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18852",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.371",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9300",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8249",
  "ui-product-approvals": "/ui-product-approvals/static-1.28948",
  "ui-tool-access": "/ui-tool-access/static-1.10377",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4002",
  "property-management-common": "/property-management-common/static-1.6201",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.558",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1009",
  "quartz-test": "/quartz-test/static-1.1009",
  "quartz-tracking": "/quartz-tracking/static-1.713",
  "trellis-components": "/trellis-components/static-1.2425",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.296",
  "bender-build-tools": "/bender-build-tools/static-1.3347",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22508",
  "ContentUtils": "/ContentUtils/static-1.69006",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13255",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2722",
  "breeze-engine-core": "/breeze-engine-core/static-1.795",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.572",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40680",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13402",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15278",
  "ExportDialog": "/ExportDialog/static-6.10604",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41866",
  "reporting-snowflake": "/reporting-snowflake/static-1.57110",
  "reporting-ui-components": "/reporting-ui-components/static-2.65763",
  "reporting-visualizations": "/reporting-visualizations/static-1.60568",
  "trellis-theming": "/trellis-theming/static-1.1180",
  "ui-addon-teams": "/ui-addon-teams/static-1.21830",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.429",
  "magpie-lib": "/magpie-lib/static-1.5706",
  "navigation-components": "/navigation-components/static-1.18681",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1517",
  "magpie-types": "/magpie-types/static-1.5166",
  "simple-logging-lib": "/simple-logging-lib/static-1.3273",
  "fail-safe": "/fail-safe/static-1.175",
  "app-governance-lib": "/app-governance-lib/static-1.2246",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10722",
  "purchase-motions-components": "/purchase-motions-components/static-1.6256",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9929",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5998",
  "usage-tracker-public": "/usage-tracker-public/static-1.7392",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3926",
  "reference-resolvers": "/reference-resolvers/static-1.8406",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4144",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.560",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3235",
  "final-form": "/final-form/static-1.73",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3399",
  "atom": "/atom/static-1.5300",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.98",
  "react-codemirror": "/react-codemirror/static-1.10864",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4980",
  "content-assistance-lib": "/content-assistance-lib/static-1.8102",
  "content-media-capture": "/content-media-capture/static-1.5235",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10050",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24303",
  "growth-payments-core": "/growth-payments-core/static-1.26026",
  "knowledge-content-types": "/knowledge-content-types/static-1.8614",
  "payment-link-components": "/payment-link-components/static-1.24036",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20203",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10110",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9305",
  "video-components-external": "/video-components-external/static-1.11999",
  "video-data-lib": "/video-data-lib/static-1.35657",
  "navigation-messaging": "/navigation-messaging/static-1.8008",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58559",
  "react-dnd-compat": "/react-dnd-compat/static-1.4840",
  "batch-promise": "/batch-promise/static-1.1769",
  "crm-component-utils": "/crm-component-utils/static-1.39690",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6113",
  "customer-data-properties": "/customer-data-properties/static-1.52364",
  "external-options-client-types": "/external-options-client-types/static-1.4283",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7117",
  "property-value-citations": "/property-value-citations/static-1.2978",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8323",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10486",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "cms-field-types": "/cms-field-types/static-1.5039",
  "content-icons-ui": "/content-icons-ui/static-1.2294",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.110",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.740",
  "pulse": "/pulse/static-1.847",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7473",
  "crm-message-bus": "/crm-message-bus/static-1.43587",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23115",
  "events-data-lib": "/events-data-lib/static-1.465",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4949",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4164",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7022",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1220",
  "onboarding-tours": "/onboarding-tours/static-1.17007",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14325",
  "academy-common-lib": "/academy-common-lib/static-1.14738",
  "dashboard-lib": "/dashboard-lib/static-1.82489",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19066",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18844",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8928",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11314",
  "user-context": "/user-context/static-1.5337",
  "reporting-plugins": "/reporting-plugins/static-1.10671",
  "reporting-reports": "/reporting-reports/static-1.68170",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.944",
  "nest": "/nest/static-1.462",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.495",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.126",
  "framework-listing-lib": "/framework-listing-lib/static-2.29327",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31263",
  "apps-service-types": "/apps-service-types/static-1.3990",
  "oauth-service-types": "/oauth-service-types/static-1.4478",
  "onboarding-scopes": "/onboarding-scopes/static-1.6683",
  "purchase-motions-api": "/purchase-motions-api/static-1.6259",
  "signup-constants": "/signup-constants/static-1.19451",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8282",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5221",
  "one-click-checkout": "/one-click-checkout/static-1.305",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7827",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15169",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3736",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9946",
  "redux-thunk": "/redux-thunk/static-2.43",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29171",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13039",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4649",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.557",
  "ui-addon-opt": "/ui-addon-opt/static-4.8586",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6502",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5304",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3760",
  "data-token-picker": "/data-token-picker/static-1.16785",
  "FileManagerLib": "/FileManagerLib/static-1.39943",
  "content-media-compositions": "/content-media-compositions/static-2.17046",
  "media-bridge-lib": "/media-bridge-lib/static-1.19305",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22499",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3356",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7093",
  "card-properties-lib": "/card-properties-lib/static-1.44858",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37633",
  "crm-actions": "/crm-actions/static-1.6574",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44321",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9815",
  "customer-data-tracking": "/customer-data-tracking/static-1.7107",
  "hs-resources": "/hs-resources/static-1.411",
  "calling-global-api": "/calling-global-api/static-1.65291",
  "calling-internal-common": "/calling-internal-common/static-1.31540",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66673",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58967",
  "commerce-products-lib": "/commerce-products-lib/static-1.10356",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3954",
  "crm-links": "/crm-links/static-1.6543",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4442",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4292",
  "formula-editor": "/formula-editor/static-1.14643",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4368",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.859",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3848",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49468",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4124",
  "smart-property-lib": "/smart-property-lib/static-1.8132",
  "tiered-pricing": "/tiered-pricing/static-1.1823",
  "topics-actions-lib": "/topics-actions-lib/static-1.382",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11210",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.236",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.350",
  "event-emitter": "/event-emitter/static-1.1176",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1484",
  "growth-data-modal": "/growth-data-modal/static-1.5786",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3285",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2550",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1073",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7867",
  "academy-service-client": "/academy-service-client/static-1.3914",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39802",
  "SafeStorage": "/SafeStorage/static-1.4627",
  "video-embed": "/video-embed/static-1.36491",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24876",
  "viral-links-lib": "/viral-links-lib/static-1.7297",
  "nested-table": "/nested-table/static-1.459",
  "timezone-utils": "/timezone-utils/static-2.5471",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18184",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9940",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5550",
  "customer-data-views-management": "/customer-data-views-management/static-1.25899",
  "framework-data-table": "/framework-data-table/static-2.12406",
  "nudge-client-utils": "/nudge-client-utils/static-1.3034",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1388",
  "switchboard-lib": "/switchboard-lib/static-1.444",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1437",
  "app-users-service-client": "/app-users-service-client/static-1.5842",
  "app-users-service-types": "/app-users-service-types/static-1.5250",
  "mini-checkout-client": "/mini-checkout-client/static-1.27400",
  "onboarding-utils": "/onboarding-utils/static-1.5587",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2105",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29156",
  "checkout-sdk": "/checkout-sdk/static-3.24243",
  "payment-method-components": "/payment-method-components/static-1.7072",
  "touchless-buying-components": "/touchless-buying-components/static-1.6111",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3709",
  "edison-service-client-types": "/edison-service-client-types/static-1.613",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6806",
  "audio-components": "/audio-components/static-1.6243",
  "FileManagerImages": "/FileManagerImages/static-1.37454",
  "video-components": "/video-components/static-1.14001",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92693",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46603",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17694",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4485",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1657",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19887",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19090",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10920",
  "crm-fe-perf": "/crm-fe-perf/static-1.23123",
  "calling-error-reporting": "/calling-error-reporting/static-1.31547",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11263",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6763",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1809",
  "commerce-permissions": "/commerce-permissions/static-1.1001",
  "products-iframe-lib": "/products-iframe-lib/static-1.8456",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10870",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6665",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10571",
  "sales-views-client-types": "/sales-views-client-types/static-1.4481",
  "bark-lib": "/bark-lib/static-1.16729",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.540",
  "policy-lib": "/policy-lib/static-1.7017",
  "react-tinymce": "/react-tinymce/static-1.55831",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10634",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54957",
  "tinymce-plugins": "/tinymce-plugins/static-1.58071",
  "tinymce-themes": "/tinymce-themes/static-1.56927",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2356",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2578",
  "user-context-client": "/user-context-client/static-1.4754",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4757",
  "outpost": "/outpost/static-1.4387",
  "draft-convert": "/draft-convert/static-2.76",
  "draft-extend": "/draft-extend/static-3.79",
  "draft-js": "/draft-js/static-5.81",
  "draft-plugins": "/draft-plugins/static-2.22052",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4069",
  "ts-utils-lib": "/ts-utils-lib/static-1.399",
  "crm-export-dialog": "/crm-export-dialog/static-1.6509",
  "crm-view-components": "/crm-view-components/static-1.945",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.66",
  "customer-data-associations": "/customer-data-associations/static-1.7556",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2791",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3110",
  "whisper-core-api": "/whisper-core-api/static-1.7180",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15413",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46703",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.826",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4215",
  "company-details-components": "/company-details-components/static-1.6426",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.778",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15355",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3679",
  "social-insights-client-types": "/social-insights-client-types/static-1.22664",
  "crm_universal": "/crm_universal/static-1.22391",
  "customer-data-email": "/customer-data-email/static-1.18420",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37827",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40056",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13097",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55460",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22047",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18639",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72695",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5558",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10073",
  "utility-belt": "/utility-belt/static-1.2756",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23666",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7891",
  "customer-data-rte": "/customer-data-rte/static-1.33523",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6160",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5331",
  "qrcode-generator": "/qrcode-generator/static-1.72",
  "quotes-client-types": "/quotes-client-types/static-1.38785",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36586",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16224",
  "hub-http-contrib": "/hub-http-contrib/static-1.3263",
  "interframe": "/interframe/static-3.4979",
  "tinymce-data": "/tinymce-data/static-1.41042",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5437",
  "layout-dnd-components": "/layout-dnd-components/static-1.12858",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11833",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16139",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9206",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7831",
  "access-control-lib": "/access-control-lib/static-1.10662",
  "EmailComponents": "/EmailComponents/static-1.55408",
  "EmailData": "/EmailData/static-1.54086",
  "redux-less": "/redux-less/static-2.9704",
  "company-details-service-types": "/company-details-service-types/static-1.4163",
  "segments-query-core": "/segments-query-core/static-1.1647",
  "pricing-pages-api": "/pricing-pages-api/static-1.15220",
  "sequences-lib": "/sequences-lib/static-1.8417",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10578",
  "products-ui-components": "/products-ui-components/static-1.40874",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7433",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55476",
  "commerce-products-api": "/commerce-products-api/static-1.2613",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57534",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103373",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81416",
  "stripe-connect-js": "/stripe-connect-js/static-1.74",
  "draft-content-plugins": "/draft-content-plugins/static-1.28787",
  "ContentData": "/ContentData/static-1.69081",
  "layout-data-lib": "/layout-data-lib/static-1.10158",
  "ContentComponents": "/ContentComponents/static-2.71962",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10816",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2060",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46984",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1846",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19520",
  "automation-ui-types": "/automation-ui-types/static-1.20438",
  "messaging-types-lib": "/messaging-types-lib/static-1.46721",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4733",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8274",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.765",
  "price-books-api": "/price-books-api/static-1.1575",
  "price-books-components": "/price-books-components/static-1.1633",
  "property-description-translator": "/property-description-translator/static-1.4063",
  "ramp-editor": "/ramp-editor/static-1.757",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3748",
  "totals-ui-components": "/totals-ui-components/static-1.24166",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9541",
  "advanced-menus-core": "/advanced-menus-core/static-1.15484",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12369",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34666",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6354",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7558",
  "data-token-views": "/data-token-views/static-1.16766",
  "forms-utils-lib": "/forms-utils-lib/static-1.12986",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13475",
  "simple-menus-core": "/simple-menus-core/static-1.15483",
  "simple-menus-lib": "/simple-menus-lib/static-1.17000",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7146",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7731",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.125",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3637",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2648",
  "ContentEditorUI": "/ContentEditorUI/static-2.77747",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4145",
  "web-interactives-components": "/web-interactives-components/static-1.14142",
  "web-interactives-data": "/web-interactives-data/static-1.14143",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1295",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1465",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1202",
  "line-items-api": "/line-items-api/static-1.1010",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3973",
  "FireAlarmUi": "/FireAlarmUi/static-1.4665",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4325",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22374",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21837",
  "data-studio-ubb": "/data-studio-ubb/static-1.3369",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27531",
  "content-management-data-lib": "/content-management-data-lib/static-1.5836",
  "copilot-plugins": "/copilot-plugins/static-1.11672",
  "cta-picker": "/cta-picker/static-1.36954",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3735",
  "editor-components": "/editor-components/static-1.13547",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8705",
  "error-messaging-js": "/error-messaging-js/static-1.5419",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86441",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.68",
  "redux-request-state": "/redux-request-state/static-1.10873",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1970",
  "smart-content-core": "/smart-content-core/static-1.43036",
  "smart-content-lib": "/smart-content-lib/static-1.43689",
  "social-composer-lib": "/social-composer-lib/static-1.60004",
  "structured-content-lib": "/structured-content-lib/static-1.25781",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53807",
  "tinymce-copilot": "/tinymce-copilot/static-1.17025",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8182",
  "automation-ui-routing": "/automation-ui-routing/static-1.21795",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5829",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42666",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3422",
  "reporting-enablement": "/reporting-enablement/static-1.23665",
  "forms-ai-lib": "/forms-ai-lib/static-1.4658",
  "codemirror-dlb": "/codemirror-dlb/static-1.59306",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6663",
  "report-customization-components": "/report-customization-components/static-1.13755",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13627",
  "reporting-filters": "/reporting-filters/static-1.871",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2412"
}
};
